import React, { useEffect, useState } from 'react'
import { Form, Grid, Button } from 'semantic-ui-react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import PropTypes from 'prop-types'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import styles from './alert-view.module.css'
import {
  SendCommandDevice,
  GetAllDeviceInfo,
} from '../../../../services/device-page-list'
import {
  updateDynamicAlertSettings,
  // getCustomerSettings,
} from '../../../../services/customer'

const initialState = {
  alarm: 'disable',
  status: '',
  notify: 'disable',
  notifyStatus: '',
  threshold: 0,
  thresholdS8: 0,
  samples: '',
  volume: '',
}

const formValidator = {
  alarm: yup.string(),
  status: yup.string(),
  threshold: yup.string().when('alarm', {
    is: 'enable',
    then: yup.string().required('Threshold is required'),
  }),
  thresholdS8: yup.string().when('status', {
    is: 'both',
    then: yup.string().required('Threshold 2 is required'),
  }),
  volume: yup.string(),
  notify: yup.string(),
  notifyStatus: yup.string(),
}

const DynamicAlertSettings = ({ deviceDetails, setViewAlert, viewAlert }) => {
  const [alarmCheck, setAlarmCheck] = useState(initialState)
  const [retrievedData, setRetrievedData] = useState({})

  const { register, handleSubmit, getValues, setValue, errors } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })

  console.log('eq volume: ', alarmCheck.volume)

  const handleChange = (e) => {
    e.persist()
    if (e.target.name === 'threshold') {
      setAlarmCheck((prevState) => ({
        ...prevState,
        volume:
          // eslint-disable-next-line no-nested-ternary
          deviceDetails.type === 'SQ' || deviceDetails.type === 'REC'
            ? (
                deviceDetails.length *
                deviceDetails.width *
                getValues('threshold')
              )
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            : // eslint-disable-next-line no-nested-ternary
            deviceDetails.type === 'HC'
            ? (
                (22 / 7) *
                (getValues('threshold') / 2) *
                (getValues('threshold') / 2) *
                deviceDetails.length
              )
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            : deviceDetails.type === 'CVC'
            ? (
                (22 / 7) *
                (deviceDetails.diameter / 2) *
                (deviceDetails.diameter / 2) *
                getValues('threshold')
              )
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            : null,
        [e.target.name]: e.target.value,
      }))
    } else
      setAlarmCheck((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }))
  }

  // eslint-disable-next-line no-unused-vars
  const getDynamicSettings = (dynamicSettings) => {
    const S7 = dynamicSettings.substring(55, 57)
    const S8 = dynamicSettings.substring(61, 64)
    const settings = {
      s7: parseInt(S7, 16),
      s8: parseInt(S8, 16),
    }
    console.log(settings.s7, settings.s8)
    return settings
  }

  const calculateSamplingRate = (settings) => {
    const rate = settings.substr(3, 2)
    return rate[0] === '0' ? '1' : '15'
  }

  useEffect(() => {
    if (viewAlert) {
      ;(async () => {
        const data = await GetAllDeviceInfo(deviceDetails.deviceId)
        setRetrievedData(data)
        // let sett
        // sett = getDynamicSettings(data.settings)
        setAlarmCheck((prevState) => ({
          ...prevState,
          threshold: data.threshold_1,
          thresholdS8: data.threshold_2,
          samples: data.samples,
          volume: data.equivalent_volume,
        }))
        setValue('volume', data.equivalent_volume)
        if (data.alarm_rising && data.alarm_falling) {
          setAlarmCheck((prevState) => ({
            ...prevState,
            alarm: 'enable',
            status: 'both',
          }))
        } else if (data.alarm_rising) {
          setAlarmCheck((prevState) => ({
            ...prevState,
            alarm: 'enable',
            status: 'rising',
          }))
        } else if (data.alarm_falling) {
          setAlarmCheck((prevState) => ({
            ...prevState,
            alarm: 'enable',
            status: 'falling',
          }))
        }
        if (data.falling && data.rising) {
          setAlarmCheck((prevState) => ({
            ...prevState,
            notify: 'enable',
            notifyStatus: 'both',
          }))
        } else if (data.falling)
          setAlarmCheck((prevState) => ({
            ...prevState,
            notify: 'enable',
            notifyStatus: 'falling',
          }))
        else if (data.rising)
          setAlarmCheck((prevState) => ({
            ...prevState,
            notify: 'enable',
            notifyStatus: 'rising',
          }))

        console.log('device data get: ', data)
      })()
    }
  }, [viewAlert])

  useEffect(() => {
    if (!retrievedData.volume) {
      setValue('volume', 0)
    }
  }, [getValues('alarm')])

  let command = 'S7=00,S8=00'
  let formula = ''
  let formulaS8 = ''

  const submitHandler = (e) => {
    console.log('form data sent: ', e)
    if (alarmCheck.alarm === 'disable') {
      command = 'S7=00,S8=00'
    } else if (alarmCheck.status === 'rising') {
      formula = (1 * 2 ** 7 + 1 * 2 ** 6 + e.threshold * 10).toString(16)
      command = `S7=${formula},S8=00`
    } else if (alarmCheck.status === 'falling') {
      formula = (1 * 2 ** 6 + e.threshold * 10).toString(16)
      command = `S7=${formula},S8=00`
    } else if (alarmCheck.status === 'both') {
      formula = (1 * 2 ** 6 + e.threshold * 10).toString(16)
      formulaS8 = (1 * 2 ** 6 + e.thresholdS8 * 10).toString(16)
      command = `S7=${formula},S8=${formulaS8}`
    }

    Swal.showLoading()
    SendCommandDevice(deviceDetails.imei, command).then((data) => {
      if (data === 200) {
        updateDynamicAlertSettings(deviceDetails.deviceId, e).then(() => {
          Swal.fire({
            title: 'Dynamic Alert Settings Set Successfully!',
            confirmButtonColor: 'Green',
            icon: 'success',
          })
          setViewAlert(false)
        })
      } else {
        Swal.fire({
          title: 'Error Setting Dynamic Alert Settings!',
          confirmButtonColor: 'Red',
          icon: 'error',
        })
      }
    })
  }

  return (
    <div>
      <Form
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
        id="staticAlertForm"
        onSubmit={handleSubmit(submitHandler)}
        widths="equal"
      >
        <Form.Field>
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <span style={{ color: 'black' }}>Enable Alarms?</span>
                <select
                  ref={register}
                  name="alarm"
                  value={alarmCheck.alarm}
                  onChange={handleChange}
                >
                  <option value="enable">Enable</option>
                  <option value="disable" selected>
                    Disable
                  </option>
                </select>
                <small style={{ color: 'red' }}>**</small>
              </Grid.Column>
            </Grid.Row>
            {alarmCheck.alarm === 'enable' ? (
              <>
                <Grid.Row>
                  <Grid.Column>
                    <span style={{ color: 'black' }}>Alarm Type:</span>
                    <select
                      name="status"
                      ref={register}
                      value={alarmCheck.status}
                      onChange={handleChange}
                    >
                      <option value="falling">Falling</option>
                      <option value="rising">Rising</option>
                      <option value="both">Both</option>
                    </select>
                    <small style={{ color: 'red' }}>**</small>
                  </Grid.Column>
                  <Grid.Column>
                    <span style={{ color: 'black' }}>
                      {alarmCheck.status === 'both'
                        ? 'Height Threshold 1 (0.1 cm - 6.3 cm):'
                        : 'Height Threshold (0.1 cm - 6.3 cm):'}
                    </span>
                    <div
                      style={{
                        display: 'flex',
                      }}
                    >
                      <input
                        name="threshold"
                        ref={register}
                        type="number"
                        onChange={handleChange}
                        value={alarmCheck.threshold}
                        min={0.1}
                        max={6.3}
                        step={0.1}
                        placeholder="Enter a valid number"
                      />

                      <span style={{ width: '135px', paddingLeft: '5px' }}>
                        Per{' '}
                        {deviceDetails.settings
                          ? `(${calculateSamplingRate(deviceDetails.settings)})`
                          : '-'}{' '}
                        minute
                      </span>
                    </div>
                    <small style={{ color: 'red' }}>**</small>
                    {errors.threshold && alarmCheck.status === 'both' && (
                      <p style={{ color: 'red' }}>Threshold 1 is required</p>
                    )}
                    {errors.threshold && alarmCheck.status !== 'both' && (
                      <p style={{ color: 'red' }}>{errors.threshold.message}</p>
                    )}
                    <br />
                  </Grid.Column>
                  <Grid.Column>
                    <span style={{ color: 'black' }}>
                      Height Equivalent Volume (
                      <span style={{ fontSize: '15px' }}>
                        cm <sup>3</sup>{' '}
                      </span>
                      ) :
                    </span>
                    <input
                      name="volume"
                      ref={register}
                      style={{ backgroundColor: '#ededed' }}
                      // type="number"
                      value={alarmCheck.volume}
                      readOnly
                    />
                    <small style={{ color: 'red' }}>**</small>
                  </Grid.Column>
                  {alarmCheck.status === 'both' ? (
                    <>
                      <Grid.Column></Grid.Column>
                      <Grid.Column>
                        <span style={{ color: 'black' }}>
                          Height Threshold 2 (0.1 cm - 6.3 cm):
                        </span>
                        <input
                          name="thresholdS8"
                          ref={register}
                          type="number"
                          onChange={handleChange}
                          value={alarmCheck.thresholdS8}
                          min={0.1}
                          max={6.3}
                          step={0.1}
                          placeholder="Enter a valid number"
                        />
                        <small style={{ color: 'red' }}>**</small>
                        {errors.thresholdS8 && (
                          <p style={{ color: 'red' }}>
                            {errors.thresholdS8.message}
                          </p>
                        )}
                      </Grid.Column>
                      <Grid.Column></Grid.Column>
                    </>
                  ) : null}
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <span style={{ color: 'black' }}>
                      Confirmation Samples (3-5):
                    </span>
                    <input
                      name="samples"
                      ref={register}
                      type="number"
                      value={alarmCheck.samples}
                      min={3}
                      max={5}
                      onChange={handleChange}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <span style={{ color: 'black' }}>
                      Get Mail Notifications?
                    </span>
                    <select
                      ref={register}
                      name="notify"
                      value={alarmCheck.notify}
                      onChange={handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable" selected>
                        Disable
                      </option>
                    </select>
                    <small style={{ color: 'red' }}>**</small>
                  </Grid.Column>
                  {alarmCheck.notify === 'enable' ? (
                    <Grid.Column>
                      <span style={{ color: 'black' }}>
                        Notification Status:
                      </span>
                      <select
                        name="notifyStatus"
                        ref={register}
                        value={alarmCheck.notifyStatus}
                        onChange={handleChange}
                      >
                        <option value="falling">Falling</option>
                        <option value="rising">Rising</option>
                        <option value="both">Both</option>
                      </select>
                      <small style={{ color: 'red' }}>**</small>
                    </Grid.Column>
                  ) : null}
                </Grid.Row>
              </>
            ) : null}
          </Grid>
        </Form.Field>
        <Form.Field>
          <hr />
          <Grid>
            <Grid.Column textAlign="center">
              <Button
                from="staticAlertForm"
                type="submit"
                className={styles.button}
                color="red"
              >
                Submit
              </Button>
            </Grid.Column>
          </Grid>
        </Form.Field>
      </Form>
    </div>
  )
}

DynamicAlertSettings.propTypes = {
  deviceDetails: PropTypes.func.isRequired,
  setViewAlert: PropTypes.func.isRequired,
  viewAlert: PropTypes.bool.isRequired,
}

export default DynamicAlertSettings
